import { Close } from '@mui/icons-material';
import { IconButton, TextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

export type ClearableTextFieldProps = {
  disableClearable?: boolean;
} & TextFieldProps;

const ClearableTextField = forwardRef<
  React.ComponentRef<typeof TextField>,
  ClearableTextFieldProps
>(({ disableClearable, ...props }, ref) => {
  const handleClear = () => {
    if (props.onChange) {
      const syntheticEvent = {
        target: { value: '' },
        currentTarget: { value: '' },
      } as React.ChangeEvent<HTMLInputElement>;

      props.onChange(syntheticEvent);
    }
  };

  return (
    <TextField
      ref={ref}
      {...props}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <>
            {props.value && !disableClearable && (
              <IconButton
                size='small'
                sx={theme => ({
                  position: 'absolute',
                  right: '0.8rem',
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: '50%',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  zIndex: 1,
                  '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                  },
                })}
                onClick={handleClear}
              >
                <Close fontSize='small' />
              </IconButton>
            )}
            {props.InputProps?.endAdornment}
          </>
        ),
      }}
    />
  );
});

ClearableTextField.displayName = 'ClearableTextField';

export default ClearableTextField;
